import ContactInfoForm from 'features/users/components/organisms/ContactInfoForm/ContactInfoForm';

export default ContactInfoForm;
